import React from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';

import logoFallback from '../../logo.png';
import { readTenantBranding } from '../../utils/tenantBrandingCache';
import { resolvePdfHeaderFields, pdfLogoSrcFromBranding } from '../../utils/pdfFooterBranding';
import {
  resolvePdfBrandColors,
  pdfHeaderRuleNeutral,
  PDF_HEADER_LOGO_WIDTH,
  PDF_HEADER_LOGO_HEIGHT,
  PDF_HEADER_LOGO_COL_FRAC,
} from '../../utils/pdfBrandColors';

const styles = StyleSheet.create({
  outer: {
    marginBottom: 10,
    width: '100%',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    minHeight: PDF_HEADER_LOGO_HEIGHT,
  },
  logoCol: {
    width: `${Math.round(PDF_HEADER_LOGO_COL_FRAC * 100)}%`,
    maxWidth: PDF_HEADER_LOGO_WIDTH + 32,
    flexShrink: 0,
    justifyContent: 'center',
  },
  logo: {
    width: PDF_HEADER_LOGO_WIDTH,
    maxWidth: '100%',
    height: PDF_HEADER_LOGO_HEIGHT,
    objectFit: 'contain',
  },
  rightCol: {
    width: `${100 - Math.round(PDF_HEADER_LOGO_COL_FRAC * 100)}%`,
    maxWidth: '100%',
    alignItems: 'flex-end',
    paddingLeft: 10,
    flexShrink: 1,
  },
});

/**
 * PDF letterhead: logo (left), slogan + address + contact (right, tenant primary color).
 */
const Header = ({ branding: brandingProp }) => {
  const branding = brandingProp ?? readTenantBranding();
  const { primary } = resolvePdfBrandColors(branding);
  const h = resolvePdfHeaderFields(branding);
  const logoSrc = pdfLogoSrcFromBranding(branding, logoFallback);

  const addressPhoneLine = [h.addressOneLine, h.supportPhone].filter(Boolean).join('. ');
  const ruleNeutral = pdfHeaderRuleNeutral();

  const sloganStyle = {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: primary,
    textAlign: 'right',
    marginBottom: 4,
    width: '100%',
  };
  const contactStyle = {
    fontSize: 8,
    color: primary,
    textAlign: 'right',
    lineHeight: 1.35,
    marginBottom: 2,
    width: '100%',
  };

  return (
    <View style={styles.outer} wrap={false}>
      <View style={styles.row}>
        <View style={styles.logoCol}>
          <Image style={styles.logo} src={logoSrc} />
        </View>
        <View style={styles.rightCol}>
          <Text style={sloganStyle}>{h.headerTagline}</Text>
          {addressPhoneLine ? (
            <Text style={contactStyle}>{addressPhoneLine}</Text>
          ) : null}
          <Text style={contactStyle}>
            E: {h.supportEmail}
            {'    '}
            W: {h.footerWebsite}
          </Text>
        </View>
      </View>
      <View style={{ height: 1, backgroundColor: ruleNeutral, width: '100%', marginTop: 8 }} />
      <View style={{ height: 1, backgroundColor: primary, width: '100%', marginTop: 2 }} />
    </View>
  );
};

export default Header;
